import {extractDomain} from "@/util/htmlUtils";
import {WeetEvent, WeetEventName} from "@/weet/weetEvent";
import axios from "axios";
import {WeetRepresentation} from "@/models/weet.models";


export const onGenericWeetEditingMessage = (event: MessageEvent, weetEndpoint: string,chapterId:number=0
                                         ):WeetEvent|null => {
  if(isAWeetMessage(event,weetEndpoint)){
    const weetEvent = event.data as WeetEvent;
    if(chapterId>0) {
      if (weetEvent.name === WeetEventName.AIAVATAR_DURATION) {
        updateAICreditsConsumption(weetEvent.data.weetID, chapterId, weetEvent.data.seconds,WeetEventName.AIAVATAR_DURATION)
      }
      if(weetEvent.name===WeetEventName.IMAGE_PRO_MODE){
        updateAICreditsConsumption(weetEvent.data.weetID, chapterId, weetEvent.data.credits,WeetEventName.IMAGE_PRO_MODE)
      }
      if (weetEvent.name === WeetEventName.VIDEO_GENERATION_DURATION) {
        updateAICreditsConsumption(weetEvent.data.weetID, chapterId, weetEvent.data.seconds,WeetEventName.VIDEO_GENERATION_DURATION)
      }
      if (weetEvent.name === WeetEventName.TTS_USAGE) {
        updateAICreditsConsumption(weetEvent.data.weetID, chapterId, weetEvent.data.credits,WeetEventName.TTS_USAGE)
      }
      if (weetEvent.name === WeetEventName.SILENTLY_SEND_WEET_ID) {
        createSilentlyWeet(weetEvent.data.weetID, chapterId, weetEvent.data.duration)
      }

    }

    return weetEvent;
  }
  return null;
}

export const updateWeetRecorded=async (weetID:string,chapterId:number,duration:number):Promise<WeetRepresentation>=>{
  return await axios.post("/api/v2/recorder/weet", {
    weetID: weetID,
    duration: duration / 1000,
    chapitreId: chapterId + "",
  }).then((response) => {
    return response.data
  })
}

const createSilentlyWeet=(weetID:string,chapterId:number,duration:number)=>{
  axios.post("/api/v2/recorder/silenceWeet", {
    weetID: weetID,
    duration: duration / 1000,
    chapitreId: chapterId + "",
  }).then(() => {
    console.debug("Silently update weetID in the chapter")
  })
}

const updateAICreditsConsumption=(weetID:string, chapterId:number, credits:string,type:WeetEventName)=>{
  axios.put("/api/v2/recorder/updateAICreditsConsumption", {
    weetID: weetID,
    chapitreId: chapterId + "",
    credits: credits,
    type:type
  })
}



const isAWeetMessage = (event: MessageEvent, weetEndpoint: string) => {
  return extractDomain(event.origin) === extractDomain(document.location.href)
}
